import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { SharedModule } from './@core/shared.module';
import { AppComponent } from './app.component';
import { CoreModule } from './@core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
// import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        ThemeModule.forRoot(),
        CoreModule.forRoot(),
        SharedModule,
        ToastrModule.forRoot({
            maxOpened: 3,
            autoDismiss: true,
            newestOnTop: true,
            preventDuplicates: false,
            timeOut: 2000,
            positionClass: 'toast-top-right',
        }),
        // NgxSpinnerModule,
    ],
    providers: [DatePipe],
    bootstrap: [AppComponent]
})
export class AppModule { }
